import { render, staticRenderFns } from "./JornadaPaciente.vue?vue&type=template&id=20dd6ff0&scoped=true"
import script from "./JornadaPaciente.vue?vue&type=script&lang=js"
export * from "./JornadaPaciente.vue?vue&type=script&lang=js"
import style0 from "./JornadaPaciente.vue?vue&type=style&index=0&id=20dd6ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd6ff0",
  null
  
)

export default component.exports